<template>
  <div id="app">
    <header-banner />
    <div class="page-body">
      <router-view />
    </div>

    <van-tabbar route active-color="#c97a8d" inactive-color="#a9968a">
      <van-tabbar-item replace to="/" icon="notes-o">菜&#8203;&#8203;谱</van-tabbar-item>
      <van-tabbar-item replace to="/daily" icon="bars" :badge="dailyCount || ''">今日菜单</van-tabbar-item>
      <van-tabbar-item replace to="/shopping" icon="shopping-cart-o" :badge="shoppingCount || ''">采购清单</van-tabbar-item>
      <van-tabbar-item replace to="/week" icon="calendar-o">周&#8203;&#8203;计划</van-tabbar-item>
      <van-tabbar-item replace to="/diary">
        <template #icon="{ active }">
          <svg class="diary-icon" :class="{ 'is-active': active }" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <!-- 方形底（纯描边，与其余 tab 线性图标风格统一） -->
            <rect x="3.5" y="3.5" width="25" height="25" rx="4" fill="none" stroke="currentColor" stroke-width="1.6"/>
            <!-- 叉子（左侧，三齿朝上 + 手柄） -->
            <line x1="11.2" y1="9.8" x2="11.2" y2="14.6" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
            <line x1="13.2" y1="9.8" x2="13.2" y2="14.6" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
            <line x1="15.2" y1="9.8" x2="15.2" y2="14.6" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
            <!-- 叉齿连接弧 -->
            <path d="M11.2 14.6 Q13.2 17.2 15.2 14.6" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
            <!-- 叉子手柄 -->
            <line x1="13.2" y1="15.8" x2="13.2" y2="23" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>
            <!-- 勺子（右侧，椭圆勺头 + 手柄） -->
            <ellipse cx="20.5" cy="12.4" rx="2.1" ry="3" fill="none" stroke="currentColor" stroke-width="1.5"/>
            <line x1="20.5" y1="15.4" x2="20.5" y2="23" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>
          </svg>
        </template>
        日&#8203;&#8203;记
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
import HeaderBanner from './components/HeaderBanner.vue'
import api from './api'

export default {
  name: 'App',
  components: { HeaderBanner },
  data() {
    return {
      dailyCount: 0,
      shoppingCount: 0
    }
  },
  created() {
    this.refreshCounts()
    this.$bus.$on('refresh-counts', this.refreshCounts)
  },
  beforeDestroy() {
    this.$bus.$off('refresh-counts', this.refreshCounts)
  },
  watch: {
    $route() {
      this.refreshCounts()
    }
  },
  methods: {
    async refreshCounts() {
      try {
        const [daily, shopping] = await Promise.all([api.getDailyMenu(), api.getShopping()])
        this.dailyCount = daily.length
        this.shoppingCount = shopping.filter(i => !i.checked).length
      } catch (e) {
        // 角标刷新失败不打扰用户
      }
    }
  }
}
</script>

<style>
#app {
  max-width: 520px;
  margin: 0 auto;
  min-height: 100vh;
  background: #f7ede7;
}

.page-body {
  padding-bottom: 66px; /* 原生 Vant tabbar 高度 ~50px + 余量 */
}

/* ===== 底部 tabbar：保持 Vant 原生样式，仅统一日记图标尺寸 ===== */
.van-tabbar-item__icon {
  margin-bottom: 2px !important;
}

.diary-icon {
  width: 22px;
  height: 22px;
  display: block;
  color: #a9968a; /* inactive 态默认色，覆盖 Vant 的 currentColor */
}

.diary-icon.is-active {
  color: #c97a8d; /* active 态主色 */
}



</style>
